// Resolves/applies the playable audio URL for a story onto a mutable story
// data object, respecting the manifest's `audioDisabled` override (used for
// stories that only have non-native/AI-voice audio - kept readable on the
// site but with the audio feature turned off until native audio is added).
export function applyStoryAudio(entry, storyData) {
  if (!storyData) return storyData;
  if (entry?.audioDisabled) {
    storyData.audio = null;
    storyData.audioDisabled = true;
    return storyData;
  }
  const raw = entry?.audio || storyData.audio || '';
  if (raw) {
    storyData.audio = /^https?:\/\//.test(raw) ? raw : `${process.env.PUBLIC_URL || ''}${raw}`;
  }
  return storyData;
}
